import React from 'react';
import { styled } from '@linaria/react';
import { motion } from 'framer-motion';

const Item = React.forwardRef(function Item(
  {
    primary,
    layout = true,
    style = {},
    wrapperStyle = {},
    textWrapperStyle = {},
    children,
    ...delegated
  },
  ref
) {
  return (
    <Wrapper
      ref={ref}
      layout={layout}
      initial={{ borderRadius: 4 }}
      style={{
        background: primary
          ? 'hsl(50deg 100% 90%)'
          : 'var(--color-gray-500)',
        ...style,
      }}
      {...delegated}
    >
      <InnerWrapper
        layout={layout}
        initial={{ borderRadius: 2 }}
        style={{
          color: primary ? 'black' : 'var(--color-text)',
          background: primary
            ? 'hsl(50deg 100% 50%)'
            : 'var(--color-gray-100)',
          ...wrapperStyle,
        }}
      >
        <motion.span
          layout={layout}
          style={{ display: 'inline-block', ...textWrapperStyle }}
        >
          {children}
        </motion.span>
      </InnerWrapper>
      <Reflection layout={layout} />
    </Wrapper>
  );
});

const Wrapper = styled(motion.div)`
  position: relative;
  display: flex;
  font-size: 1rem;
  padding: 2px;
  margin: 2px;
`;

const InnerWrapper = styled(motion.div)`
  flex: 1;
  padding: 10px 16px;
`;

export const Reflection = styled(motion.div)`
  position: absolute;
  top: 4px;
  left: 4px;
  right: 4px;
  height: 10px;
  width: calc(100% - 8px);
  background: linear-gradient(to top, transparent, white);
  border-radius: 9px 9px 32px 32px;
  opacity: 0.1;
`;

export default Item;
